<div class="header-container">
    <div class="left-container">
        <div class="title">{{titleText}}</div>
        <div *ngIf="subTitleText?.length" class="subtitle">{{subTitleText}}</div>
        <div *ngIf="tooltipText?.length" class="tooltip-icon">
            <app-tooltip-icon [text]="tooltipText"></app-tooltip-icon>
        </div>
    </div>
    <div class="right-container">
        <app-ask-polaris-button *ngIf="askPolarisWidget" [widget]="askPolarisWidget"
            [selectedMetrics]="selectedMetrics"></app-ask-polaris-button>
        <app-select-menu *ngIf="showSelect" [control]="control" [items]="selectOptions" [selectMode]="selectMode"
            [iconPath]="iconPath" [placeholder]="placeholder" [searchable]="searchable" [compareWith]="compareWith"
            [disabled]="selectDisabled" [width]="selectWidth" [showPlaceholderIcon]="showPlaceholderIcon"
            [searchPlaceholder]="selectSearchPlaceholder" [hideSelected]="hideSelected"
            [selectAllAndClearOptions]="selectAllAndClearOptions" [groupBySelected]="groupBySelected"
            [showAllSelected]="showAllSelected" [showSelectedIcon]="showSelectedIcon"
            [showPlaceholderAllSelected]="showPlaceholderAllSelected" [dropDownWideWidth]="selectDropdownWideWidth"
            (onApply)="onApply()">
        </app-select-menu>
        <app-select-menu *ngIf="showSecondSelect" [control]="secondControl" [items]="secondSelectOptions"
            [selectMode]="selectMode" [iconPath]="iconPath" [placeholder]="secondPlaceholder" [searchable]="searchable"
            [compareWith]="compareWith" [disabled]="selectDisabled" [width]="secondSelectWidth"
            [showPlaceholderIcon]="showPlaceholderIcon" [searchPlaceholder]="secondSelectSearchPlaceholder"
            [hideSelected]="hideSelected" [selectAllAndClearOptions]="selectAllAndClearOptions"
            [groupBySelected]="groupBySelected" [showAllSelected]="showAllSelected"
            [showSelectedIcon]="showSelectedIcon" [showPlaceholderAllSelected]="showPlaceholderAllSelected"
            [dropDownWideWidth]="selectDropdownWideWidth" (onApply)="onApply()">
        </app-select-menu>
    </div>
</div>
